"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDateList = void 0;
exports.validateAndCreateConfig = validateAndCreateConfig;
exports.validateAndCreateRelativeConfig = validateAndCreateRelativeConfig;
const _ = __importStar(require("lodash"));
const luxon_1 = require("luxon");
const common_1 = require("@finley-technologies/common");
const offset_1 = require("../utils/offset");
const range_1 = require("../utils/range");
const getDateForOccurrenceOperator = (startOfPeriodDay, month, occurrence, offset) => {
    // if `inputDay` is from the previous month, add: occurrence, otherwise add: occurrence - 1
    const weeksToAdd = startOfPeriodDay.plus({ months: 1 }).month === month
        ? occurrence
        : occurrence - 1;
    const day = startOfPeriodDay.plus({ weeks: weeksToAdd });
    return day.month === month
        ? (0, offset_1.applyOffset)({
            offset: offset ?? { days: 0, dayUnit: 'calendarDay' },
            date: day,
        })
        : null;
};
function isRecurringFrequencyPeriod(period) {
    return period !== undefined;
}
const createDateList = (recurringDateConfig) => {
    (0, common_1.finleyAssert)('type' in recurringDateConfig &&
        recurringDateConfig.type === 'weekdayByOccurrence', 'Recurring date config type must be "weekdayByOccurrence"');
    const { startDate, endDate, period, weekdays, cadence, occurrence, offset, } = recurringDateConfig;
    const startDateTime = luxon_1.DateTime.fromISO(startDate);
    const endDateTime = luxon_1.DateTime.fromISO(endDate);
    const dateList = [];
    let currentDateTime = startDateTime.startOf(period);
    // eslint-disable-next-line no-restricted-syntax
    while (currentDateTime <= endDateTime) {
        const weekYear = currentDateTime.weekYear;
        const weekNumber = currentDateTime.weekNumber;
        // get the weekdays for the first week of the month
        const daysForFirstWeek = weekdays.map((weekday) => luxon_1.DateTime.now().set({
            weekYear,
            weekNumber,
            weekday,
        }));
        const currentMonth = currentDateTime.month;
        // filter out any weekdays out of range
        const newDates = daysForFirstWeek
            .map((day) => getDateForOccurrenceOperator(day, currentMonth, occurrence, offset))
            .filter((date) => date && (0, range_1.isDateInRange)({ date, start: startDate, end: endDate }));
        if (newDates.length > 0) {
            dateList.push(...newDates);
        }
        currentDateTime = currentDateTime.plus({
            [period]: cadence,
        });
    }
    return dateList;
};
exports.createDateList = createDateList;
function validateAndCreateConfig(startDate, endDate, period, cadence = 0, offsetDayUnit = 'calendarDay', offsetDays = 0, offsetNonBusinessDayAdjustment, weekdays, occurrence) {
    const error = {};
    if (!weekdays || weekdays.length < 1) {
        error.daysOfTheWeek = 'Missing Days of the Week';
    }
    if (weekdays && weekdays.length > 7) {
        error.daysOfTheWeek = 'More than 7 days selected';
    }
    if (period === 'week') {
        error.frequency = 'Frequency cannot be `week`, must be recurring.';
    }
    if (!occurrence || occurrence < 1) {
        error.occurrence = 'Occurrence must be greater than 0';
    }
    if (!_.isEmpty(error)) {
        return { config: null, error };
    }
    if (!isRecurringFrequencyPeriod(period)) {
        return {
            config: null,
            error: { frequency: `Invalid frequency [${period}] provided.` },
        };
    }
    const offset = offsetDayUnit === 'calendarDay'
        ? {
            dayUnit: offsetDayUnit,
            days: offsetDays,
            nonBusinessDayAdjustment: offsetNonBusinessDayAdjustment,
        }
        : {
            dayUnit: offsetDayUnit,
            days: offsetDays,
        };
    const weekdayConfig = {
        type: 'weekdayByOccurrence',
        startDate,
        endDate,
        occurrence: occurrence,
        period,
        weekdays: weekdays,
        cadence,
        offset,
    };
    return { config: weekdayConfig, error: {} };
}
function validateAndCreateRelativeConfig(startDateFormula, endDateFormula, period, cadence = 0, offsetDayUnit = 'calendarDay', offsetDays = 0, offsetNonBusinessDayAdjustment, weekdays, occurrence) {
    const error = {};
    if (!weekdays || weekdays.length < 1) {
        error.daysOfTheWeek = 'Missing Days of the Week';
    }
    if (weekdays && weekdays.length > 7) {
        error.daysOfTheWeek = 'More than 7 days selected';
    }
    if (period === 'week') {
        error.frequency = 'Frequency cannot be `week`, must be recurring.';
    }
    if (!occurrence || occurrence < 1) {
        error.occurrence = 'Occurrence must be greater than 0';
    }
    if (!_.isEmpty(error)) {
        return { config: null, error };
    }
    if (!isRecurringFrequencyPeriod(period)) {
        return {
            config: null,
            error: { frequency: `Invalid frequency [${period}] provided.` },
        };
    }
    const offset = offsetDayUnit === 'calendarDay'
        ? {
            dayUnit: offsetDayUnit,
            days: offsetDays,
            nonBusinessDayAdjustment: offsetNonBusinessDayAdjustment,
        }
        : {
            dayUnit: offsetDayUnit,
            days: offsetDays,
        };
    const weekdayConfig = {
        type: 'weekdayByOccurrence',
        occurrence: occurrence,
        period,
        weekdays: weekdays,
        cadence,
        offset,
    };
    return {
        config: { startDateFormula, endDateFormula, baseDateConfig: weekdayConfig },
        error: {},
    };
}
//# sourceMappingURL=weekdayByOccurrence.js.map